import React from "react";
import LogList from "../SelectedDevice/LogList" 
import {f_101_formatDateExactly} from "../DevServices/service_functions"
const SDM_03_state_list = (props) => {
  const {rx_log_list, icons} = props

  const rx_log_list1 = [
    {
      id: 1,
      code: "HUM",
      value: "56923 3 53",
      description: "Internet enabled. IP: 192.168.0.103",
      date_created: "5/5/2025, 4:45:12 PM",
    },
    {
      id: 2,
      code: "HUM",
      value: "56923 3 53",
      description: "WiFi connected ssid: Keenetic-4010",
      date_created: "5/5/2025, 4:45:12 PM",
    },
    {
      id: 3,
      code: "TEMP",
      value: "56923 3 53",
      description: "Device Started",
      date_created: "5/5/2025, 4:45:12 PM",
    },
  ];
/* 
  const icons = {
    id: "🆔",       // ID button
    device: "📱",   // mobile phone
    code: "⌨️",     // keyboard
    value: "🔢",    // numbers
    description: "📝", // memo
    created: "🕒"   // clock
  }; */
  
  if (!rx_log_list || rx_log_list.length === 0) return null;

  //console.log(rx_log_list)

  return (
    <div className="container mt-3">
    {/* Desktop Table (hidden on mobile) */}
    <div className="d-none d-md-block">
      <LogList
        rx_log_list = {rx_log_list}
      />
    </div>

      {/* Mobile Display (hidden on desktop) */}
      <div className="d-md-none" style={{ marginLeft: "-30px", marginRight: "-30px" }}>
        <div className="list-group">
          {rx_log_list.map((item, index) => (
            <div 
              key={item.id}
              className={`list-group-item ${index % 2 === 0 ? 'bg-light' : 'bg-white'} p-1 mb-2 rounded`}
            >
              {/* Display key-value pairs with pictograms */}
              <span style={{ fontSize: '0.9rem' }}>
                id: {item.id} | type: {item.type} <br />
                {icons.description} {item.note} <br />
                {icons.created} {f_101_formatDateExactly(item.date_created)}
                {/* {icons.created} {new Date(item.date_created).toLocaleString()} */}
{/*                 code: {item.code} |
                value: {item.value} <br />
                {icons.description} {item.description} <br />
                {icons.updated} {new Date(item.date_updated).toLocaleString()} <br />
                {icons.created} {new Date(item.date_created).toLocaleString()}  */}
                </span>
{/*                 <strong>🔧</strong> {item.code} | 
                <strong>📊</strong> {item.value ?? "-"} |  icons.description
                <strong>📝</strong> {item.description ?? "-"} <br /> 
                <strong>🕒</strong> {new Date(item.date_created).toLocaleString()} */}

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SDM_03_state_list;

/* 


      <h4 className="mb-3">Sensor Status</h4>
      
      
      <div className="d-none d-md-block">
        <table className="table table-striped table-bordered">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>Code</th>
              <th>Value</th>
              <th>Description</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {rx_log_list.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.code}</td>
                <td>{item.value ?? "-"}</td>
                <td>{item.description ?? "-"}</td>
                <td>{new Date(item.date_created).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
*/